module.exports = __webpack_public_path__ + "static/media/rtr.ce5957a7.png";